import { IDomainConfig } from '../interfaces/IConfig'

const CLIENT_ID = '6a20157c4fe46fc7b3ea040b'

export const getDomainConfig = (): IDomainConfig => {
  const hostname = window.location.hostname
  const port = window.location.port
  const portSuffix = port ? `:${port}` : ''
  const parts = hostname.split('.')
  const rootDomain = parts.slice(-2).join('.')
  const envParts = parts.slice(1, -2)
  const envSegment = envParts.length > 0 ? '.' + envParts.join('.') : ''

  const buildUrl = (sub: string) => `//${sub}${envSegment}.${rootDomain}${portSuffix}`

  return {
    CLIENT_ID,
    API_SERVER: buildUrl('apiv2'),
    OAUTH_SERVER: buildUrl('oauthv2'),
    REDIRECT_URI: `${window.location.origin}/`,
  }
}

export const buildOAuthAuthorizeUrl = (domain: IDomainConfig): string => {
  const params = new URLSearchParams({
    type: 'web_server',
    redirect_uri: domain.REDIRECT_URI,
    response_type: 'code',
    client_id: domain.CLIENT_ID,
  })
  return `${domain.OAUTH_SERVER}/authorize?${params.toString()}`
}
